import { Palette, Pause, Play } from 'lucide-react';
import { Button } from '../ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';
import { EagleAppearanceFields } from './EagleAppearanceFields';

export const EagleControls = ({ preferences, paused, onToggle, onChange, saveError, disabled, idPrefix = 'home-eagle', showAppearance = true }) => <TooltipProvider delayDuration={200}>
  <div className="home-eagle-controls" data-testid={`${idPrefix}-controls`}>
    <Tooltip><TooltipTrigger asChild>
      <Button type="button" variant="ghost" size="icon" className="home-eagle-icon" data-testid={`${idPrefix}-playback`}
        disabled={disabled} aria-label={paused ? 'Play eagle animation' : 'Pause eagle animation'} onClick={onToggle}>
        {paused ? <Play size={14} /> : <Pause size={14} />}
      </Button>
    </TooltipTrigger><TooltipContent>{paused ? 'Play animation' : 'Pause animation'}</TooltipContent></Tooltip>
    {showAppearance && <Popover><Tooltip><TooltipTrigger asChild><PopoverTrigger asChild>
      <Button type="button" variant="ghost" size="icon" className="home-eagle-icon" data-testid={`${idPrefix}-appearance`}
        aria-label="Animation appearance"><Palette size={15} /></Button>
    </PopoverTrigger></TooltipTrigger><TooltipContent>Animation appearance</TooltipContent></Tooltip>
      <PopoverContent data-testid={`${idPrefix}-settings`} aria-label="Eagle animation appearance" side="top" align="end" sideOffset={8}
        className="home-eagle-settings z-[80] w-64 max-w-[calc(100vw-2rem)] space-y-4">
        <EagleAppearanceFields preferences={preferences} onChange={onChange} saveError={saveError} idPrefix={idPrefix} />
      </PopoverContent>
    </Popover>}
  </div>
</TooltipProvider>;